import React from 'react';
import serviceData from './../data/serviceData.json';
import { Link } from 'react-router-dom';

const OurService = () => {
  // We want to show only the available services from the data
  const items = serviceData;

  return (
    <>
      {/* Our Services Section Start */}
      <div className="our-services">
        <div className="container">
          <div className="row section-row align-items-center">
            <div className="col-lg-6">
              <div className="section-title">
                <h3 className="wow fadeInUp">our services</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  Innovative design services for <span>every need</span>
                </h2>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="section-title-content">
                <p className="wow fadeInUp" data-wow-delay="0.2s">
                  We offer a range of bespoke interior design services tailored to
                  your unique needs. From concept development to final installation.
                </p>
              </div>
            </div>
          </div>

          {/* Static 3x3 Grid */}
          <div className="row">
            {items.map((service, index) => (
              <div className="col-lg-4 col-md-6" key={`ourservice-${index}`}>
                <div className="service-item wow fadeInUp" data-wow-delay={`${index * 0.05}s`}>
                  <div className="service-image" style={{ position: 'relative' }}>
                    <Link to={`/services/${service.id}`} data-cursor-text="View" aria-label={`View ${service.title}`}>
                      <div className="square-img-wrapper">
                        <figure className="image-anime">
                          <img src={service.image} alt={service.title} />
                        </figure>
                      </div>
                    </Link>



                    {/* Text over image */}
                    <div className="service-overlay-text">
                      <h3>
                        <Link to={`/services/${service.id}`} data-cursor-text="View" style={{ color: 'black' }}>
                          {service.title}
                        </Link>
                      </h3>
                      <p>{service.info}</p>
                    </div>
                  </div>
                  <div className="service-btn">
                    <Link to={`/services/${service.id}`} data-cursor-text="View">
                      <img src="images/arrow-white.svg" alt="" />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Our Services Section End */}
    </>
  );
};

export default OurService;
